<template>
  <div class="new-layout-con new-layout-con-trade">
    <div class="new-page-con">
      <Home></Home>
    </div>
  </div>
</template>

<script>
import Home from "@/views/trade/home.vue";
export default {
  name: "TradeIndex",
  components: {
    Home,
  },
  data() {
    return {};
  },
};
</script>
<style scoped>
.new-layout-con-trade {
  height: 100%;
}
</style>
